// Image imports
import almogSarusiPortrait from '../../../images/almog-sarusi.jpg';

export const almogSarusiMemorial = {
  id: 16,
  name: 'Almog Sarusi',
  category: 'young-lives',
  images: {
    portrait: almogSarusiPortrait
  },
  info: `

"A vibrant, positive person who loved traveling around Israel in his white jeep with his guitar." - Hostages and Missing Families Forum

# Almog Sarusi

![Almog Sarusi](${almogSarusiPortrait})
*Almog Sarusi, whose love for life and music touched all who knew him*

## A Free Spirit

Almog Sarusi was 27 years old, a resident of Ra'anana just north of Tel Aviv, when he attended the Nova music festival on October 7th, 2023. Friends describe him as the embodiment of joy - someone who lived fully and passionately, filling rooms with his laughter and music.

Almog was one of four siblings in a close-knit family. He had been dating his girlfriend Shahar for five years, and they had traveled to the festival together to celebrate life, music, and freedom - unaware of the horror that would unfold.

## An Act of Love and Courage

When Hamas terrorists attacked the festival, Almog and Shahar tried to escape the gunfire. At some point during their flight, Shahar was wounded. Witnesses report that Almog refused to leave her side, trying desperately to help her even as terrorists approached. It was while trying to protect the woman he loved that Almog was captured and taken to Gaza.

Tragically, Shahar did not survive the attack. And Almog, whose act of love had put him in harm's way, began his 11-month ordeal in captivity.

## Adventures Interrupted

Those who knew Almog speak of his adventurous spirit. He was known for traveling across Israel in his white jeep, guitar always at hand, ready to play music around a campfire or on a beach at sunset. He had a gift for friendship, collecting people wherever he went and keeping in touch with a wide circle of friends from different parts of his life.

"Almog never met a stranger," one friend recalled. "He would strike up conversations with anyone, and by the end, you'd think they were lifelong friends."

His family described his love for the natural beauty of Israel - how he would often disappear for days, exploring hidden spots in the desert or finding secluded beaches along the coast. He documented these adventures with photographs that revealed his artistic eye and appreciation for the world around him.

## A Final Tragedy

On August 31, 2024, Israeli forces recovered Almog's body along with five other hostages from a tunnel in Rafah. According to Israeli officials, all six had been executed by their captors shortly before they were found.

At his funeral, friends played songs on guitars in his honor, creating the music that Almog himself would have played. His family spoke of their 11 months of anguish, hoping against hope that he would return to them alive.

## Remembered in Music

In Ra'anana, a music scholarship has been established in Almog's name, ensuring that his passion for music will continue to inspire others. Friends have compiled his original songs and recordings into an album, preserving his artistic voice for those who loved him and those who never had the chance to meet him.

Almog Sarusi lived his short life with such intensity and joy that his memory burns bright in the hearts of all who knew him. Though silenced too soon, the music he created and the love he shared continue to resonate.

May his memory be a blessing, and may his music play on in the hearts of those who loved him.

`
};